import { OperationType, ProductStatus } from '../../../../types';

export const netNewJiraWithApp = {
  lineItems: [
    {
      logoId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
      name: 'Jira',
      entitlementNumber: '',
      estimatedNumberOfUsers: 1,
      billingCycleLabel: 'MONTHLY',
      nextBillDate: '',
      offeringName: 'Standard',
      existingCloudSite: '',
      listPrice: 0,
      grandTotal: 0,
      isItAJiraProduct: true,
      discountPercent: 10,
      estimateIncludingPartnerDiscount: 0,
      totalDiscount: 0,
      isAdminFeeApplicable: false,
      itemLevelTaxInfo: [
        [
          'IGST',
          {
            tax: 0,
            taxPercent: 18,
          },
        ] as [string, { tax: number; taxPercent: number }],
      ],
      appLineItems: [
        {
          id: '7be35d7c-ef11-4f42-b0b6-ab73d50d4c4b',
          name: 'Zephyr for Jira - Test Management Cloud',
          logoId: '71807254-cbe2-4574-aaf8-c37ba7eefc4e',
          billingCycle: 'MONTHLY',
          containerOrProductId: 'e3c038bd-e534-4157-8c68-e7d7777bce45',
          activeUsers: '1',
          customerContacts: [],
          productId: 'f5b80773-ed5f-46b6-ac81-a12a9124a34e',
          pricingPlanId: 'c608d465-6b08-4a45-aeb8-a115c2c40f10',
          offeringId: 'e22079e3-66f9-4ce4-9914-dcea676e4ed0',
          offeringName: 'Standard',
          operationType: OperationType.NEW,
          productStatuses: [ProductStatus.NEW],
          trialLengthInDays: '30',
          promotions: [],
          parentEntitlementId: '',
          nextBillingTimestamp: '',
          inTrial: true,
          hasAllData: true,
          grandTotal: 0,
          listPrice: 0,
          totalDiscount: 0,
          totalPartnerDiscount: 0,
          totalOtherDiscount: 0,
          discountPercent: 10,
          total: 0,
          totalTax: 0,
          estimateIncludingPartnerDiscount: 0,
          allPromotionsApplied: [],
          isAdminFeeApplicable: false,
          itemLevelTaxInfo: [
            [
              'IGST',
              {
                tax: 0,
                taxPercent: 18,
              },
            ] as [string, { tax: number; taxPercent: number }],
          ],
        },
      ],
      isFreeProduct: false,
      adminFee: 0,
      totalPriceOfApps: 0,
      productKey: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
      lineItemId: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
      id: '31c2d221-c496-48da-9f4a-c9c74cf9a53b',
      productStatuses: [ProductStatus.NEW],
      trialLengthInDays: '14',
      inTrial: true,
      initialOfferingName: 'Standard',
      isItADowngrade: false,
      isItAUpgrade: false,
      newPlanStartDate: '',
    },
  ],
  loading: false,
  nextBillDate: {},
  selectedCurrency: 'USD',
  showSandboxStatus: true,
};
